// extracted by css-extract-rspack-plugin
export default {"list":"ui__list___QbA9g"};